import fetch from 'utils/fetch'

export function getDictList(names, other = {}) {
    return fetch({
        url: `/admin/sysDict/name`,
        method: 'GET',
        params: { names: names.join(',') },
        ...other
    })
}
// 查询字典表
// export function getDictList(params,other = {}) {
//     return fetch({
//         url: `/admin/sysDict/list`,
//         method: 'GET',
//         params,
//         ...other
//     })
// }
// 获取地区
export function getSimpleRegion(data, other = {}) {
    return fetch({
        url: `/admin/sysRegion/simple`,
        method: 'GET',
        params: data,
        ...other
    })
}
